import React from "react";
import { Route, Routes } from "react-router-dom";
import SiteAllowence from "../AllowenceItems/SiteAllowance";
import WorkerAllowence from "../AllowenceItems/WorkerAllowance";
import PayrollAllowance from "../AllowenceItems/PayrollAllowance";
import TaskAllowence from "../AllowenceItems/TaskAllowance";
import SpecificAllowance from "../AllowenceItems/SpecificAllowance";

const AllowanceRoutes = () => {
  return (
    <Routes>
      <Route path="site-allowance" element={<SiteAllowence />} />
      <Route path="worker-allowance" element={<WorkerAllowence />} />
      <Route path="task-allowance" element={<TaskAllowence />} />
      <Route path="payroll-category-allowance" element={<PayrollAllowance />} />
      <Route path="specific-allowance" element={<SpecificAllowance />} />
    </Routes>
  );
};

export default AllowanceRoutes;
